(() => {
  if (window.swinger && window.swinger.config) {
    return;
  }

  const configMeta = document.querySelector('meta[name="config"]');
  const configJSON = configMeta.getAttribute('content') || '{}';

  window.swinger = { ...window.swinger, config: JSON.parse(configJSON) };
  window.swinger.config.retargetingParams = [
    'bid',
    'adcref',
    'ocode',
    'cid',
  ];

  try {
    // eslint-disable-next-line no-storage/no-browser-storage
    const meJSON = window.localStorage.getItem('me');

    if (!meJSON) {
      return;
    }

    const me = JSON.parse(meJSON);

    window.swinger.config.currency = me.currency || 'EUR';
  } catch (e) {
    // noop
  }
})();
